import React from "react";
import { ListingType } from "common/types/CommonDto";
import { ActiveListingsStatus } from "office/reports/activeListings/ActiveListingsReport";
import { LeadChannel, LeadReason } from "office/reports/leads/LeadsReport";
import { FilterDropdownWithState } from "common/ui/components/table/FilterDropdownWithState";
import HoverInfoWrapper from "common/ui/components/tooltips/HoverInfoWrapper";
import * as ReportHelper from "common/utils/reportHelper";
import EnumHelper from "common/utils/EnumHelper";
export const columnHeader = (props) => {
    return (React.createElement("div", { className: "griddleColumn" },
        React.createElement(HoverInfoWrapper, { tipText: props.tip },
            React.createElement("div", { className: "griddleColumnText" }, props.displayName)),
        React.createElement("span", { className: "fa fa-sort" })));
};
export const columnHeaderWithSub = (props) => {
    return (React.createElement("div", null,
        React.createElement("div", { className: "griddleColumn" },
            React.createElement(HoverInfoWrapper, { tipText: props.tip },
                React.createElement("div", { className: "griddleColumnText" }, props.displayName)),
            React.createElement("span", { className: "fa fa-sort" })),
        React.createElement(HoverInfoWrapper, { tipText: props.subHeadingTip },
            React.createElement("div", { className: "griddleColumnText griddleColumnSubHeading" }, props.subHeading))));
};
export const columnHeaderTotals = (props) => {
    return (React.createElement("div", null,
        React.createElement("div", { className: "griddleColumn" },
            React.createElement(HoverInfoWrapper, { tipText: props.tip },
                React.createElement("div", { className: "griddleColumnText griddleColumnTextRotated" }, props.displayName)),
            React.createElement("span", { className: "fa fa-sort" })),
        React.createElement(HoverInfoWrapper, { tipText: props.totalTip },
            React.createElement("div", { className: "griddleColumnText griddleColumnTextTotals" }, ReportHelper.formatBigNumber(props.total)))));
};
export const columnHeaderRotated = (props) => {
    return (React.createElement("div", { className: "griddleColumn" },
        React.createElement(HoverInfoWrapper, { tipText: props.tip },
            React.createElement("div", { className: "griddleColumnText griddleColumnTextRotated" }, props.displayName)),
        React.createElement("span", { className: "fa fa-sort" })));
};
export const listingTypeHeader = (props) => {
    const filterOptions = [
        { keyName: "All", displayName: "All", filterText: "" },
        { keyName: ListingType[ListingType.Sales], displayName: ListingType[ListingType.Sales], filterText: ListingType[ListingType.Sales] },
        { keyName: ListingType[ListingType.Rentals], displayName: ListingType[ListingType.Rentals], filterText: ListingType[ListingType.Rentals] }
    ];
    return (React.createElement("div", { className: "griddleColumn" },
        React.createElement(HoverInfoWrapper, { tipText: props.tip },
            React.createElement("div", { className: "griddleColumnText" }, props.displayName)),
        React.createElement(FilterDropdownWithState, { filterName: props.displayName, columnName: props.columnName, filterByColumn: props.filterByColumn, filters: filterOptions, selection: props.selection })));
};
export const leadChannelHeader = (props) => {
    const text = (type) => {
        const name = EnumHelper.GetDescription(LeadChannel, type);
        return { keyName: name, displayName: name, filterText: name };
    };
    const filter = [
        { keyName: "All", displayName: "All", filterText: "" },
        text(LeadChannel.Email),
        text(LeadChannel.CallMeBack)
    ];
    return (React.createElement("div", { className: "griddleColumn" },
        React.createElement(HoverInfoWrapper, { tipText: props.tip },
            React.createElement("div", { className: "griddleColumnText" }, props.displayName)),
        React.createElement(FilterDropdownWithState, { filterName: props.displayName, columnName: props.columnName, filterByColumn: props.filterByColumn, filters: filter, selection: props.selection })));
};
export const leadToHeader = (props) => {
    const filter = [
        { keyName: "All", displayName: "All", filterText: "" },
        { keyName: "Office Direct", displayName: "Office Direct", filterText: "Office Direct" },
        { keyName: "Office Billboard", displayName: "Office Billboard", filterText: "Office Billboard" }
    ];
    if (props.agentNames && props.agentNames.length > 0) {
        props.agentNames.forEach((name) => {
            if (name != "Office") {
                filter.push({ keyName: name, displayName: name, filterText: name });
            }
        });
    }
    return (React.createElement("div", { className: "griddleColumn" },
        React.createElement(HoverInfoWrapper, { tipText: props.tip },
            React.createElement("div", { className: "griddleColumnText" }, props.displayName)),
        React.createElement(FilterDropdownWithState, { filterName: props.displayName, columnName: props.columnName, filterByColumn: props.filterByColumn, filters: filter, selection: props.selection })));
};
export const leadReasonHeader = (props) => {
    const text = (type) => {
        const name = EnumHelper.GetDescription(LeadReason, type);
        return { keyName: name, displayName: name, filterText: name };
    };
    const filter = [
        { keyName: "All", displayName: "All", filterText: "" },
        { keyName: "ListingHeading", title: "Leads to a Listing" },
        text(LeadReason.SaleListing),
        text(LeadReason.RentalListing),
        { keyName: "AgentOfficeHeading", title: "Leads directly to an Agent or Office" },
        text(LeadReason.Buying),
        text(LeadReason.Selling),
        text(LeadReason.RentOut),
        text(LeadReason.FindToRent),
        text(LeadReason.Other),
        { keyName: "DevelopmentHeading", title: "Leads to a Development" },
        text(LeadReason.Development)
    ];
    return (React.createElement("div", { className: "griddleColumn" },
        React.createElement(HoverInfoWrapper, { tipText: props.tip },
            React.createElement("div", { className: "griddleColumnText" }, props.displayName)),
        React.createElement(FilterDropdownWithState, { filterName: props.displayName, columnName: props.columnName, filterByColumn: props.filterByColumn, filters: filter, selection: props.selection })));
};
export const listingStatusHeader = (props) => {
    const text = (type) => {
        const name = EnumHelper.GetDescription(ActiveListingsStatus, type);
        return { keyName: name, displayName: name, filterText: name };
    };
    const filter = [
        { keyName: "All", displayName: "All", filterText: "" },
        text(ActiveListingsStatus.New),
        text(ActiveListingsStatus.OnShow),
        text(ActiveListingsStatus.PriceReduced),
        text(ActiveListingsStatus.BackOnMarket),
        text(ActiveListingsStatus.Sold),
        text(ActiveListingsStatus.Negotiable),
        text(ActiveListingsStatus.OfferPending)
    ];
    return (React.createElement("div", { className: "griddleColumn" },
        React.createElement(HoverInfoWrapper, { tipText: props.tip },
            React.createElement("div", { className: "griddleColumnText" }, props.displayName)),
        React.createElement(FilterDropdownWithState, { filterName: props.displayName, columnName: props.columnName, filterByColumn: props.filterByColumn, filters: filter, selection: props.selection })));
};
